import styled from "@emotion/styled";

export const StyledContextItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  padding: ${({ theme }) => `${theme.spacing["2"]} ${theme.spacing["1"]}`};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};

  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  user-select: none;
`;

export const StyledContextIcon = styled.span`
  width: 16px;
  height: 16px;

  .mds-icon {
    font-size: 14px;
    width: 16px;
    height: 16px;
  }
`;

export const StyledContextText = styled.span`
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;
